import Icon, { IconType } from "@edaz/edazkit/Icon";
import { DataTable } from "@frui.ts/dataviews";
import type { ColumnDefinition } from "@frui.ts/dataviews/dist/dataTypes";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import type RefundApprovedResponse from "entities/refundApprovedResponse";
import { observer } from "mobx-react-lite";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { formatAmount, translateGeneral } from "utils/localizations";
import RefundsDisapprovalViewModel from "viewModels/finance/bankAccountBlacklists/refundsDisapprovalViewModel";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import { emptyValue } from "utils/emptyValue";

const RefundsDisapprovalView: ViewComponent<RefundsDisapprovalViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<RefundApprovedResponse>[] = [
    {
      property: "licensePlate",
      title: vm.translateAttribute("licensePlate"),
      valueFormatter: props =>
        props.item.licensePlate && props.item.countryCode ? `${props.item.countryCode}-${props.item.licensePlate}` : emptyValue,
    },
    {
      property: "bankAccount",
      title: vm.translateAttribute("bankAccount"),
      valueFormatter: props => formatBankAccount(props.value),
    },
    {
      property: "variableSymbol",
      title: vm.translateAttribute("variableSymbol"),
    },
    {
      property: "refundReason",
      title: vm.translateAttribute("refundReason"),
    },
    {
      property: "amount",
      title: vm.translateAttribute("amount"),
      valueFormatter: props => formatAmount(props.value),
    },
  ];

  return (
    <Modal
      centered={true}
      show={vm.isOpened}
      onHide={vm.cancel}
      onEscapeKeyDown={vm.cancel}
      dialogClassName="modal-90w confirm-dialog"
      backdropClassName="confirm-dialog-backdrop">
      <Modal.Body className="justify-content-center text-center">
        <div className="align-items-center mb-4 row">
          <div className="col col-auto">
            <div className="border-2 border-danger border rounded-circle">
              <Icon icon={IconType.Error} width={64} height={64} />
            </div>
          </div>
          <div className="col">
            <Modal.Title as="h3" className="mb-1">
              {vm.translate("title")}
            </Modal.Title>
            <span className="font-weight-bold text-danger">{vm.translate("description", vm.refunds.length)}</span>
          </div>
        </div>
        <DataTable columns={columns} items={vm.refunds} itemKey="refundId" className="text-nowrap table table-striped" />
      </Modal.Body>
      <Modal.Footer className="justify-content-end">
        <Button onClick={vm.cancel} variant="light">
          {translateGeneral("cancel")}
        </Button>
        <Button onClick={vm.confirm} variant="danger">
          {translateGeneral("confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default registerView(RefundsDisapprovalView, RefundsDisapprovalViewModel);
